module.exports = __webpack_public_path__ + "static/media/artur.8e41949d.png";